import "./PaymentHistory.css";

import { FineType, HistoryModel } from "../../../models/fineModels";
import { faArrowLeft, faSearch } from "@fortawesome/free-solid-svg-icons";

import CustomInput from "../../CustomInput/CustomInput";
import DesktopHistoryTable from "./DesktopHistoryTable/DesktopHistoryTable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import MobileHistoryTable from "./MobileHistoryTable/MobileHistoryTable";
import ReactLoading from "react-loading";
import { getPaymentHistory } from "../../../api/infringement";
import { useEffect } from "react";
import { useState } from "react";

interface PaymentHistoryProps {
  setProfileSection: (section: any) => void;
}

const PaymentHistory = ({ setProfileSection }: PaymentHistoryProps) => {
  const [data, setData] = useState<HistoryModel[] | null>(null);
  const [historyLoading, setHistoryLoading] = useState<boolean>(false);
  const [search, setSearch] = useState<string | null>(null);
  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    setHistoryLoading(true);
    const history = await getPaymentHistory();
    if (history) setData(history);
    setHistoryLoading(false);
  };

  const renderSection = () => {
    if (window.innerWidth <= 480)
      return <MobileHistoryTable data={data} search={search} />;
    return <DesktopHistoryTable data={data} />;
  };

  const onSort = (val: string) => {
    let sortedFines = data;
    if (sortedFines) {
      sortedFines = sortedFines
        ?.slice()
        .sort((a: HistoryModel, b: HistoryModel) => {
          if (a && b) {
            let aWarrant = a.warrant_status === FineType.WARRANT;
            let aDate = a.date_paid;
            let bWarrant = b.warrant_status === FineType.WARRANT;
            let bDate = b.date_paid;
            switch (val) {
              case "1":
                return (
                  Number(bWarrant) - Number(aWarrant) ||
                  new Date(aDate).getTime() - new Date(bDate).getTime()
                );
              case "2":
                return (
                  Number(bWarrant) - Number(aWarrant) ||
                  new Date(bDate).getTime() - new Date(aDate).getTime()
                );
              case "3":
                return (
                  Number(aWarrant) - Number(bWarrant) ||
                  new Date(aDate).getTime() - new Date(bDate).getTime()
                );
              case "4":
                return (
                  Number(aWarrant) - Number(bWarrant) ||
                  new Date(bDate).getTime() - new Date(aDate).getTime()
                );
              default:
                break;
            }
          }
          return 0;
        });
    }
    setData(sortedFines);
  };

  return (
    <div className="payment-history-container">
      <div className="payment-history-headings">
        {window.innerWidth <= 480 ? (
          <div
            className="profile-details-header"
            onClick={() => setProfileSection(null)}
          >
            <FontAwesomeIcon icon={faArrowLeft} size="1x" color="#18283c" />
            <p>Payment History</p>
          </div>
        ) : (
          <p className="payment-history-heading">Payment History</p>
        )}
        <p className="payment-history-subheading">
          History of fully-paid notices:
        </p>
        {window.innerWidth <= 480 ? (
          <div>
            <select
              className="mobile-fine-dropdown"
              onChange={(e) => onSort(e.target.value)}
            >
              <option>Sort by Due Date</option>
              <option value={1}>Warrants from Oldest to Newest</option>
              <option value={2}>Warrants from Newest to Oldest</option>
              <option value={3}>Fines from Oldest to Newest</option>
              <option value={4}>Fines from Newest to Oldest</option>
            </select>
            <CustomInput
              placeholder="Search"
              value={search}
              setValue={setSearch}
              inputStyle={{
                fontSize: 13,
                width: "66%",
                height: 24,
              }}
              inputContainerStyle={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
              }}
              icon={<FontAwesomeIcon icon={faSearch} className="search-icon" />}
            />
          </div>
        ) : null}
      </div>
      {data && data.length > 0 ? (
        renderSection()
      ) : historyLoading ? (
        <div className="history-loading">
          <ReactLoading type="bubbles" color="#e97700" width={50} />
        </div>
      ) : (
        <p className="no-fines-text">You have not paid any fines</p>
      )}
    </div>
  );
};

export default PaymentHistory;
